// extracted by mini-css-extract-plugin
module.exports = {"control":"Control_control__9O1mn","button":"Control_button__u0ykq"};